var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGaana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: 13.819,
    cy: 13.5412,
    r: 13.0019,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.07956
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6929 8.96014C16.0353 8.95644 16.3759 8.96014 16.7479 8.96014C16.7027 9.23429 16.6621 9.49551 16.6169 9.75397C16.3695 11.1764 16.1184 12.6007 15.8683 14.0241C15.7104 14.9176 15.5655 15.812 15.3864 16.7037C15.1455 17.9185 14.2317 18.4779 13.2929 18.6145C13.0656 18.641 12.8368 18.6525 12.608 18.6486C11.8178 18.6523 11.0268 18.6486 10.2357 18.6486C10.2204 18.6474 10.2055 18.6437 10.1914 18.6376C10.1951 18.6182 10.1914 18.596 10.2006 18.5794C10.4222 18.1788 10.6382 17.7791 10.8689 17.3859C10.9031 17.3305 11.0065 17.2917 11.0785 17.2917C11.7735 17.2843 12.464 17.288 13.1591 17.288C13.688 17.288 13.9594 17.0693 14.0729 16.5431C14.1283 16.3244 14.1587 16.1157 14.2077 15.8647C14.0877 15.8647 13.9907 15.8684 13.8938 15.8647C13.4194 15.8527 12.9412 15.8739 12.4705 15.8222C11.7578 15.7391 11.2631 15.2868 11.1219 14.6638C11.0434 14.3222 11.0886 13.9844 11.1468 13.6465C11.3046 12.7493 11.4569 11.8475 11.6249 10.9512C11.828 9.86474 12.6569 9.08475 13.7535 8.99891C14.3969 8.94629 15.0458 8.9666 15.692 8.96014H15.6929ZM13.8024 10.3207C13.3428 10.3281 13.0298 10.5949 12.9468 11.0592C12.8572 11.5595 12.7649 12.057 12.6791 12.5582C12.6034 13.0078 12.5175 13.4564 12.4668 13.9087C12.428 14.2318 12.6025 14.5179 12.9292 14.5179H14.215C14.3784 14.5179 14.4532 14.4616 14.4809 14.2955C14.6627 13.2025 14.852 12.1096 15.0403 11.0167C15.1141 10.6069 14.9064 10.3374 14.4901 10.3244C14.2603 10.317 14.0332 10.3207 13.8024 10.3207Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaana);
export default __webpack_public_path__ + "static/media/Gaana.03d2e54420f33b69f84491cea3fc3698.svg";
export { ForwardRef as ReactComponent };